import { Box, Button, Grid, Link, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonCTAOnboarding from './components/ButtonCTAOnboarding';
import OnboardingInput from './components/OnboardingInput';
import TestimonialsCarousel from './components/TestimonialsCarousel';

export const InsertBusinessWebsiteOnboarding = () => {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const theme = useTheme();

  const handleContinue = () => {
    navigate('');
  };
  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#19191C',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 400,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            color={theme.palette.common.white}
            fontFamily="Space Grotesk"
            variant="h6"
            fontSize={25}
            fontWeight={700}
            mt={2}
            mb={1}
          >
            Hi there, sing up to Oppy!
          </Typography>
          <Typography
            color={theme.palette.common.white}
            fontSize={16}
            fontFamily="Space Grotesk"
            variant="subtitle1"
            fontWeight={400}
            mb={4}
          >
            Enter your business website to begin.
          </Typography>

          <OnboardingInput
            placeholder="oppy.pro"
            margin="normal"
            label="Business website URL"
          />
          <Box sx={{ width: '100%', mb: 2 }} />
          <ButtonCTAOnboarding label="Continue" onClick={handleContinue} />

          <Typography
            variant="body2"
            mt={3}
            textAlign="center"
            color={theme.palette.common.white}
          >
            Already have an account?{' '}
            <Link href="#" color="#4949C8" underline="hover">
              Sign in
            </Link>
          </Typography>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#fafafd',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: 500, textAlign: 'center', mb: 0 }}>
          <Typography
            variant="h5"
            fontFamily="Space Grotesk"
            fontWeight={700}
            color="#4949C8"
            sx={{ mb: 1 }}
          >
            Oppy's AI assistants handle <br /> your daily tasks…
          </Typography>
          <Typography variant="subtitle1" color="#222" sx={{ mb: 4 }}>
            so you can focus on showing homes, closing <br /> deals, and
            building relationships.
          </Typography>
        </Box>

        <TestimonialsCarousel />
      </Grid>
    </Grid>
  );
};
